import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/Kpi";
import { dateIt, eurShort, num } from "@/lib/format";

/** Box Importazioni: file "30 LQ" delle approvate da liquidare. Il dato resta fisso finche' non si ricarica qui. */
export function BoxApprovateDaLiquidare() {
  const [dato, setDato] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  useEffect(() => {
    api.get("/import/approvate-da-liquidare").then((r) => setDato(r.data)).catch(() => setDato({}));
  }, []);

  const carica = async (e) => {
    e.preventDefault();
    const file = fileRef.current?.files?.[0];
    if (!file) { toast.error("Seleziona un file"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/import/approvate-da-liquidare", fd,
        { headers: { "Content-Type": "multipart/form-data" } });
      setDato(data);
      fileRef.current.value = "";
      toast.success(`Approvate da liquidare aggiornate · ${num(data.pratiche)} pratiche · ${eurShort(data.importo)}`);
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };

  return (
    <Card className="p-6 !border-2 !border-amber-300" data-testid="import-box-approvate">
      <div className="uppercase text-xs tracking-[0.18em] font-semibold text-slate-500">
        Approvate da liquidare
      </div>
      <p className="text-sm text-slate-500 mt-2 mb-2 min-h-[64px]">
        File delle pratiche liquidabili (estratto "30 LQ"): alimenta il box "Approvate da liquidare"
        della Dashboard con lo spaccato AUTO / NON AUTO. Il dato resta fisso finché non ricarichi
        un file qui: gli altri import non lo toccano.
      </p>
      <p className="text-[11px] text-slate-400 mb-3">Colonne usate: IMPORTO_FINANZIATO e MACRO SETTORE (o PRODOTTO)</p>
      <form onSubmit={carica} className="flex flex-wrap items-center gap-3">
        <input type="file" accept=".xlsx,.xls,.csv,.txt" className="text-sm" ref={fileRef}
          data-testid="import-file-approvate" />
        <button type="submit" disabled={busy} data-testid="import-carica-approvate"
          className="bg-amber-600 text-white rounded-md px-4 py-2 text-sm font-medium
            hover:bg-amber-700 disabled:opacity-60 transition-colors duration-200">
          {busy ? "Elaborazione…" : "Carica e aggiorna"}
        </button>
      </form>
      {dato?.pratiche ? (
        <div className="mt-4 rounded-md bg-amber-50 border border-amber-200 px-4 py-3 text-sm"
          data-testid="approvate-dato-attuale">
          <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
            <span className="text-2xl font-bold font-mono text-slate-900">{eurShort(dato.importo)}</span>
            <span className="text-slate-600">{num(dato.pratiche)} pratiche</span>
          </div>
          <div className="mt-1 text-slate-700">
            AUTO <b className="font-mono">{eurShort(dato.auto?.importo)}</b> ({num(dato.auto?.pratiche)}) ·
            NON AUTO <b className="font-mono">{eurShort(dato.non_auto?.importo)}</b> ({num(dato.non_auto?.pratiche)})
          </div>
          <div className="mt-1 text-xs text-slate-500">
            {dato.filename} · caricato il {dateIt(dato.aggiornato_il)}
          </div>
        </div>
      ) : dato && (
        <div className="mt-4 text-xs text-slate-400" data-testid="approvate-nessun-dato">
          Nessun file caricato: la Dashboard usa il valore del PDF ufficiale.
        </div>
      )}
    </Card>
  );
}
